module.exports = __webpack_public_path__ + "img/dtms-logo.9d7adbe0.svg";